/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable, Injector } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { ContactDeliveryMethod } from '@gh/builder-shared-data';
import { TextTypes, toAppFormGroup, updateChildrenSchema } from '@gh/common-shared';
import { getControl } from '@gh/core-ui';
import {
  ContactDetailsDebtorBilling,
  ContactDetailsDebtorCommon,
} from '../../resources/model/contact-details-debtor.model';
import { ContactDetailsCommonFormState } from '../contact-details-common-tab/contact-details-common-form.service';

const getDebtorCommonBillingSchema = ({ isBillingSame, deliveryBy }: ContactDetailsDebtorBilling) => {
  const anotherBilling = !isBillingSame;
  const emailRequired = anotherBilling && deliveryBy === ContactDeliveryMethod.Email;
  const mailRequired = anotherBilling && deliveryBy === ContactDeliveryMethod.Mail;

  return {
    deliveryBy: { required: true },
    isBillingSame: void 0,
    country: { required: mailRequired, enabled: anotherBilling },
    addressee: { required: mailRequired, enabled: anotherBilling },
    street1: { required: mailRequired, enabled: anotherBilling },
    street2: { required: mailRequired, enabled: anotherBilling },
    city: { required: mailRequired, enabled: anotherBilling },
    state: { required: mailRequired, enabled: anotherBilling },
    stateCode: { required: mailRequired, enabled: anotherBilling },
    postcode: { required: mailRequired, enabled: anotherBilling },
    email: {
      required: emailRequired,
      enabled: anotherBilling,
      type: TextTypes.Email,
    },
  };
};

@Injectable()
export class ContactDetailsDebtorCommonFormState extends FormState<ContactDetailsDebtorCommon> {
  constructor(schemaFactory: BuilderFormSchemaFactory, private injector: Injector) {
    super(schemaFactory);
  }

  get commonFormState(): ContactDetailsCommonFormState {
    return this.injector.get(ContactDetailsCommonFormState);
  }

  updateBilling(): void {
    const billingGroup = toAppFormGroup(getControl(this.group, 'billing'));
    updateChildrenSchema(billingGroup, getDebtorCommonBillingSchema(billingGroup.value));
  }

  protected buildSchema(common: ContactDetailsDebtorCommon, { root, group }: FormStateSchema): FormRootSchema {
    return root({
      children: {
        billing: group({
          children: getDebtorCommonBillingSchema(common.billing),
        }),
      },
    });
  }
}
